// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import Video from 'video.js'
import vueWaterfallEasy from 'vue-waterfall-easy'
import axios from 'axios'
import pinyin from 'js-pinyin'
import store from './vuex/store.js'
import 'video.js/dist/video-js.css'
import animated from 'animate.css'
import AMap from 'vue-amap'
import "./assets/js/rem.js"
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
import scroll from 'vue-seamless-scroll'
import VueScroller from 'vue-scroller'

import directives from '../src/assets/js/directives'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {
	name: 'v-touch'
})
VueTouch.config.swipe = {

	threshold: 100 //手指左右滑动距离

}
directives(Vue)
Vue.use(VueScroller)
Vue.use(scroll)
// Vue.use(preview)
Vue.use(Vant)
Vue.use(animated)
//初始化vue-amap
Vue.use(AMap);
AMap.initAMapApiLoader({
	key: 'ed51775f704b30d7e5f759188e1c1479',
	plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar',
		'AMap.MapType',
		'AMap.PolyEditor', 'AMap.CircleEditor'
	]
})


Vue.prototype.$video = Video
Vue.prototype.$axios = axios

axios.defaults.withCredentials = true;

//测试
// global.baseUrl = 'https://cs.jbj-china.com.cn';
//线上
global.baseUrl = 'https://backstage.jbj-china.com.cn';

Vue.config.productionTip = false

/**
 * 全局方法
 */

//获取cookie
Vue.prototype.getCookie = function(cookieName) {
	var strCookie = document.cookie;
	var arrCookie = strCookie.split("; ");
	for (var i = 0; i < arrCookie.length; i++) {
		var arr = arrCookie[i].split("=");
		if (cookieName == arr[0]) {
			return arr[1];
		}
	}
	return "";
}

//返回上一级
Vue.prototype.back = () => router.back(-1)

//跳转搜索页面
Vue.prototype.serch = () => router.push({
	path: '/serch'
})

//拉起客服
Vue.prototype.open53 = function() {
	var element = document.getElementById('app')
	var newObj = document.createElement('iframe');
	var div = document.createElement('div');
	var div2 = document.createElement('div');
	div.id = "kf_box";
	div.style =
		"position:fixed;left:0;bottom:1px;width:100%;height:75vh;border-radius:10px;overflow:hidden;background:#fff; z-index:999999999;";
	element.appendChild(div);
	div2.style = "width:100%;height:40px;background:#1DABF5;line-height:40px;text-align: right;";
	div2.innerHTML = "<span id='closekf' style='color:#fff;padding-right: 10px;'  >关闭</span>";
	div.appendChild(div2);
	newObj.id = "kf_content"
	// newObj.src = "https://jbj.sobot.com/chat/h5/v2/index.html?sysnum=f263bf1694164b30987a45c136cf132f&channelid=12";
	newObj.src = "https://cschat-ccs.aliyun.com/index.htm?tntInstId=_2EVHBUm&scene=SCE00009589#/";
	newObj.style = "width:100%;height:70vh;border:none;";
	div.appendChild(newObj);
	var close = document.getElementById('closekf');
	close.onclick = function() {
		element.removeChild(div)
	};
	// window.location = "https://qiyukf.com/script/02d7eb8a78cf433b0c1ebafd26f723a3.js"
}



//验证是否登录
Vue.prototype.whatLogin = function(callback) {
	let bool = false;
	let token = localStorage.getItem('Authorization');
	if (token) {
		this.$axios.post(baseUrl + '/mobile/User/whatLogin', {
			token: token
		}).then(function(res) {
			if (res.data.code == 1001) {
				callback(true);
			} else {
				callback(false);
			}
		}).catch(function(err) {
			console.log(err);
		});
	} else {
		callback(false);
	}
}


//上传图片
Vue.prototype.upload = function(event, callback) {
	this.$axios.post(baseUrl + '/mobile/Index/img_Upload', event, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	}).then((res) => {
		if (res.data.code == 11) {
			callback(res.data.data);
		} else {
			this.$toast('上传失败');
		}
	}).catch(() => {})
}
//单张上传图片
Vue.prototype.upload_d = function(event, callback) {
	this.$axios.post(baseUrl + '/mobile/Index/imgUpload', event, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	}).then((res) => {
		if (res.data.code == 11) {
			callback(res.data.data);
		} else {
			this.$toast('上传失败');
		}
	}).catch(() => {})
}
//解决跨域方法
Vue.prototype.getJSON = function(url, param, cb) {
	// 方法归类
	let method = {
		isArray: (value) => {
			return Object.prototype.toString.call(value) === '[object Array]';
		},
		isObject: (value) => {
			return typeof value === 'object' && !!value;
		},
		isString: (value) => {
			return typeof param === 'string';
		},
		isNull: (value) => {
			return typeof value === 'null';
		},
		isUndefined: (value) => {
			return typeof value === 'undefined';
		},
		isNumber: (value) => {
			return typeof value === 'number';
		},
		isBool: (value) => {
			return typeof value === 'boolean';
		},
		isSymbol: (value) => {
			return typeof value === 'symbol';
		},
		handleArrayParam: (param) => {
			let str = '';
			param.forEach((key) => {
				if (method.isObject(key)) {
					str += key + '=' + param[key] + '&';
				} else {
					throw 'invalid current param!';
				}
			});
			return str;
		}, //处理数组参数
		handleObjectParam: (param) => {
			let str = '';
			Object.keys(param).forEach((key) => {
				str += key + '=' + param[key] + '&';
			});
			return str;
		}, //处理对象参数
	};
	// 定义最后的参数
	let curParam;
	if (method.isNull(param) || method.isUndefined(param)) {
		curParam = '';
	} else if (method.isObject(param)) {
		curParam = method.handleObjectParam(param);
	} else if (method.isArray(param)) {
		curParam = method.handleArrayParam(param);
	} else if (method.isString(param)) {
		if (param.match('&')) {
			curParam = param;
		} else {
			throw 'invalid current param!';
		}
	} else {
		throw 'you should pass in an object param or a string param or param about containing object in array!';
	}
	const head = document.getElementsByTagName('head')[0];
	const script = document.createElement('script');
	script.src = url + '?' + curParam + '&callback=jsonp';
	script.id = "jsonp";
	head.appendChild(script);
	window['jsonp'] = function(data) {
		cb(data);
		if (head) {
			head.removeChild(document.getElementById('jsonp'));
		}
	}
};
//返回不刷新页免
router.beforeEach((to, from, next) => {
	//to（当前页面） form（前一页面）
	//判断当前页是不是目标页，再判断前一页面是否要缓存
	if (to.name == 'interviewDetail' && from.name == 'interviewManagement') {
		from.meta.keepAlive = true;
	} else {
		from.meta.keepAlive = false;
	}
	next();
});

/**
 * 全局过滤器
 */

//测试
// Vue.filter('handleUrl', function (value) {
//   return 'https://cs.jbj-china.com.cn/uploads/' + value;
// })

//线上
Vue.filter('handleUrl', function(value) {
	return 'https://backstage.jbj-china.com.cn/uploads/' + value;
})

var handleUrl = Vue.filter('handleUrl');

//过大价格调整
Vue.filter('formarter', function(value) {
	if (parseInt(value) > 1999) {
		return '面议';
	} else {
		return '¥' + value;
	}
})

//手机号隐藏4位
Vue.filter('phoneNumFilter', function(phone) {
	// 1字符串转化成数组
	let phoneArr = [...phone];
	let str = '';
	// 2.将数组中的4-7位变成*
	phoneArr.map((res, index) => {
		if (index > 2 && index < 7) {
			str += '*';
		} else {
			str += res;
		}
	});
	return str;
})

new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js